/* floatingButton
========================================================= */
export function floatingButton($) {
  const $window = $(window);
  const $floatingSp = $('#floating__btn--sp');
  const $floatingPc = $('#floating__btn--pc');

  if (!$floatingSp.length && !$floatingPc.length) {
    return;
  }

  const mediaQuery = window.matchMedia('(max-width: 519px)');

  $floatingSp.hide();
  $floatingPc.hide();

  function updateFloatingButton() {
    const isVisible = $window.scrollTop() > 100;

    if (!isVisible) {
      $floatingSp.stop(true, true).fadeOut();
      $floatingPc.stop(true, true).fadeOut();
      return;
    }

    if (mediaQuery.matches) {
      $floatingSp.stop(true, true).fadeIn();
      $floatingPc.stop(true, true).hide();
    } else {
      $floatingPc.stop(true, true).fadeIn();
      $floatingSp.stop(true, true).hide();
    }
  }

  $window.on('scroll.floatingButton', updateFloatingButton);

  if (typeof mediaQuery.addEventListener === 'function') {
    mediaQuery.addEventListener('change', updateFloatingButton);
  } else {
    mediaQuery.addListener(updateFloatingButton);
  }

  updateFloatingButton();
}
